export default {"src":"/_next/static/media/no-data-found.78f7401d.svg","height":259,"width":213,"blurWidth":0,"blurHeight":0};